import moment from 'moment';
import { getFirebase } from '../../modules/firebase';
import { encryptWithSecret } from '../../utils';
import * as fetchHelpers from '../Fetch';
import { getCurrentUser } from './auth';

export async function sendEmailVerification() {
  const user = await getCurrentUser();
  return user.sendEmailVerification();
}

export function resetPassword(email) {
  const API_URL = fetchHelpers.API_URL;
  const firebase = getFirebase();
  firebase.auth().signOut();
  const timestamp = moment.utc().valueOf();
  return firebase.auth().sendPasswordResetEmail(email, {
    url:
      API_URL +
      'user/login/reset/?token=' +
      encodeURIComponent(encryptWithSecret(`${email} ${timestamp}`)),
  });
}
